<!--
// app/components/pages/region-stats/cards-featured-stats/PlaceholderTeamShield.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 10,
  width: 10,
});
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 412 537" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M205.984 0L210.614 1.49429L398.845 62.1464L411.952 66.3708L408.968 79.8356L408.965 79.848C408.706 81.0368 395.07 143.559 395.07 207.545C395.07 248.325 397.648 283.861 399.72 312.429L399.724 312.485L399.738 312.679C401.014 330.309 402.023 344.249 402.023 354.43C402.023 379.873 399.603 410.187 370.71 448.118C351.852 472.875 317.458 494.562 271.263 510.838C266.899 512.372 261.616 514.077 256.018 515.878C241.257 520.628 222.891 526.548 213.558 531.968L205.976 536.37L198.394 531.968C189.071 526.562 170.731 520.647 155.986 515.892L155.985 515.892L155.983 515.891L155.942 515.878C150.344 514.077 145.061 512.372 140.697 510.838C94.5025 494.57 60.1086 472.883 41.2501 448.118C12.3573 410.195 9.93745 379.873 9.93745 354.43C9.93745 344.249 10.9448 330.33 12.2193 312.72L12.2363 312.485L12.2391 312.446C14.3116 283.875 16.8904 248.325 16.8904 207.545C16.8904 143.258 3.12965 80.4575 2.99253 79.8356L0 66.3708L13.1155 62.1464L201.354 1.49429L205.984 0Z"
      fill="currentColor"
    />
  </svg>
</template>

<style scoped></style>
